<section lvCloseOverlay withKeyboard="esc" after="1s">
  <aside>
    <div class="icon"></div>
    <p translate>done-auditing.component.{{ passOrFail }}-user</p>
    <p>
      <b>{{ session.learner.name }}</b>
    </p>
  </aside>
</section>
